const config = {
  appName: "ProLedger",
  hostName: process.env.REACT_APP_HOSTNAME || "localhost",
  apiUrl: process.env.REACT_APP_APIURL || "/api/",
  relativePath: process.env.REACT_APP_RELATIVE_PATH || "",
};

export default config
